import GLOBALS from '../utils/Constants';
import UserService from './users-service';

class WidgetsService{
  	static sharedInstance = WidgetsService.sharedInstance ? this.sharedInstance : new WidgetsService();

    constructor(){
    	//initialize
	    this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    getUpdatedCrendetials(){
    	this.credentials = UserService.sharedInstance.getStoredCredentials();
	    this.auth_username = this.credentials.username;
	    this.license = this.credentials.license;
	    this.token = this.credentials.token;
    }

    async getEventIncidentsSummary(event_id){

    	this.getUpdatedCrendetials();

	  	const params = {
	        "license": this.license,
	        "auth_username": this.auth_username,
	        "token":  this.token,
	        "event_id": event_id
	    }

	    const formBody = UserService.sharedInstance.urlEncodeParams(params);
	    let response = await fetch(GLOBALS.GET_EVENT_INCIDENTS_SUMMARY_API+"&"+formBody, {
	        method: 'GET',
	        headers: {
	            'Content-Type':'application/x-www-form-urlencoded'
	        },
	    });
	    
	    const responseJson = await response.json();

	    try {
	        UserService.sharedInstance.checkIfTokenIsValid(responseJson);
	        return responseJson;
	    } catch (error) {
	        console.error("error");
	        console.error(error);
	    }
	}
}

export default WidgetsService;
